var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],class:_vm.$style.table,attrs:{"keys":_vm.config.keys,"data":_vm.showList,"paginationBackground":false,"colOptions":_vm.colOptions,"pagerData":{
        allCount: _vm.allCount,
        pageSize: _vm.pageSize,
        page: _vm.page,
      }},on:{"page-change":function($event){_vm.page = $event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }